<template>

    <div>
      <dialog-add-user v-if="me" ref="dialogAddUser" :is_business="me.company_type != 'agency'"></dialog-add-user>
  
      <panel-navigation>
  
        <div class="float-right ml-5 -mt-1">
          <!-- <div class="border-1 border-blue bg-blue text-white text-xs text-bold px-4 py-2 rounded cursor-pointer float-right ml-2" @click="$refs.dialogAddUser.createUser(); $refs.dialogAddUser.show()" style="margin-top: -5px;"><i class="fa fa-plus mr-2"> </i> ADD USER</div> -->
        </div>
  
        <div class="container flex flex-row items-center justify-between">
            <h1 class="text-lg font-semibold mt-5">User</h1>
            <div class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer float-right" @click="$router.push({ name: 'adminusers'})" style="margin-top: -5px;"><i class="fa fa-arrow-left mr-2"> </i> BACK</div>
        </div>
  
        <hr class="border-b border-gray-100 mb-3">
  
        <v-skeleton-loader v-if="!search" type="article, article, article"></v-skeleton-loader>

  
        <template v-else>
          <div class="dashboard-box">
            <v-card
              class="pa-2"
              tile
            >
              <div class="p-3">

                <v-container  v-if="search">
                        <div class="p-3 table-responsive">
                            <table class="table table-bordered" >
                                    <tbody>
                                       <tr>
                                            <th scope="row" class="text-left">FIRST NAME:</th>
                                            <td class="text-left text-capitalize">{{search['FIRST_NAME'] ? search['FIRST_NAME']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">LAST NAME:</th>
                                            <td class="text-left text-capitalize">{{search['LAST_NAME'] ? search['LAST_NAME']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">STRIPE STATUS:</th>
                                            <td class="text-left text-capitalize">{{search['STRIPE_STATUS'] ? search['STRIPE_STATUS']:'-'}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="text-left">SUBSCRIPTION NAME:</th>
                                            <td class="text-left">{{search['SUBSCRIPTION_NAME'] ? search['SUBSCRIPTION_NAME']:'-'}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="text-left">BILLING AMOUNT($):</th>
                                            <td class="text-left">{{search['BILLING_AMOUNT'] ? search['BILLING_AMOUNT']:'-'}}</td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="text-left"> PAYMENT UPDATE LINK:</th>
                                            <td class="text-left"> <a :href="search['PAY_FAIL']" target="_blank">{{ search['PAY_FAIL'] }}</a></td>
                                        </tr>
                                        <tr>
                                            <th scope="row" class="text-left">COMPANY NAME:</th>
                                            <td class="text-left"><strong>{{search['COMPANY_NAME'] ? search['COMPANY_NAME']:'-'}}</strong></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">AGENCY ACTIVE PAID SUBSCRIBERS:</th>
                                            <td class="text-left">{{search['ACTIVE_PAID_SUBSCRIBERS'] ? search['ACTIVE_PAID_SUBSCRIBERS']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">ACTIVE STRIPE REVENUE($):</th>
                                            <td class="text-left">{{search['ACTIVE_STRIPE_REVENUE'] ? search['ACTIVE_STRIPE_REVENUE']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">FIRST BUSINESS SETUP COUNT:</th>
                                            <td class="text-left">{{search['FIRST_BUSINESS_SETUP_COUNT'] ? search['FIRST_BUSINESS_SETUP_COUNT']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">COMPANY TYPE:</th>
                                            <td class="text-left">{{search['COMPANY_TYPE'] ? search['COMPANY_TYPE']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">TOTAL SPENT($):</th>
                                            <td class="text-left">{{search['TOTAL_SPENT'] ? search['TOTAL_SPENT']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">USING STRIPE INTEGRATION:</th>
                                            <td class="text-left">{{search['USING_STRIPE_INTEGRATION'] ? search['USING_STRIPE_INTEGRATION']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">WHITE LABEL DOMAIN SETUP:</th>
                                            <td class="text-left">{{search['WHITE_LABEL_DOMAIN_SETUP'] ? search['WHITE_LABEL_DOMAIN_SETUP']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">LAST LOGIN:</th>
                                            <td class="text-left">{{ formatDate(search['LAST_LOGIN']) }}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">LAST INOVICE:</th>
                                            <td class="text-left">{{ search['LAST_INVOICE'] ? formatDate(search['LAST_INVOICE']):'-' }}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">LAST INVOICE ID:</th>
                                            <td class="text-left">{{ search['INVOICE_ID'] ? search['INVOICE_ID']:'-' }}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">INVOICE DATE:</th>
                                            <td class="text-left">{{ search['LAST_INVOICE_TIMESTAMP'] ? search['LAST_INVOICE_TIMESTAMP']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">SUBSCRIPTION END DATE:</th>
                                            <td class="text-left">{{ search['SUBSCRIPTION_END'] ? formatDate(search['SUBSCRIPTION_END']):'-'}}</td>
                                        </tr>


                                        <tr>
                                            <th scope="row" class="text-left">INVOICE STATUS:</th>
                                            <td class="text-left">{{ search['INVOICE_STATUS'] ? search['INVOICE_STATUS']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">INVOICE DESCRIPTION:</th>
                                            <td class="text-left">{{ search['INVOICE_DESCRIPTION'] ? search['INVOICE_DESCRIPTION']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">INVOICE AMOUNT:</th>
                                            <td class="text-left">{{ search['INVOICE_AMOUNT'] ? search['INVOICE_AMOUNT']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">FAILURE REASON:</th>
                                            <td class="text-left">{{ search['FAILURE_REASON'] ? search['FAILURE_REASON']:'-'}}</td>
                                        </tr>


                                        <tr>
                                            <th scope="row" class="text-left">SIGNUP FLOW STEP 1:</th>
                                            <td class="text-left" v-html="search['SIGNUP_FLOW_STEP1'] ? `<strong>Email</strong>: ${JSON.parse(search['SIGNUP_FLOW_STEP1']).EMAIL}` : '-'"></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">SIGNUP FLOW STEP 2:</th>
                                            <td class="text-left" v-html="search['SIGNUP_FLOW_STEP2'] ? `<strong>First Name</strong>: ${JSON.parse(search['SIGNUP_FLOW_STEP2']).FIRST_NAME},</br> <strong> Last Name </strong>:${JSON.parse(search['SIGNUP_FLOW_STEP2']).LAST_NAME}` : '-'"></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">SIGNUP FLOW STEP 3:</th>
                                            <td class="text-left" v-html="search['SIGNUP_FLOW_STEP3'] ? `<strong>Business</strong>: ${JSON.parse(search['SIGNUP_FLOW_STEP3']).BUSINESS},</br> <strong> Time Zone </strong>:${JSON.parse(search['SIGNUP_FLOW_STEP3']).TIME_ZONE}` : '-'"></td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">ONBOARD_FLOW_STEP1.2:</th>
                                            <td class="text-left">{{ search['ONBOARD_FLOW_STEP1.2'] ? search['ONBOARD_FLOW_STEP1.2']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">ONBOARD_FLOW_STEP1.3:</th>
                                            <td class="text-left">{{ search['ONBOARD_FLOW_STEP1.3'] ? search['ONBOARD_FLOW_STEP1.3']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">ONBOARD_FLOW_STEP1.4</th>
                                            <td class="text-left">{{ search['ONBOARD_FLOW_STEP1.4'] ? search['ONBOARD_FLOW_STEP1.4']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">ONBOARD FLOW STEP 2:</th>
                                            <td class="text-left">{{ search['ONBOARD_FLOW_STEP2'] ? search['ONBOARD_FLOW_STEP2']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left">ONBOARD FLOW STEP 3:</th>
                                            <td class="text-left">{{ search['ONBOARD_FLOW_STEP3'] ? search['ONBOARD_FLOW_STEP3']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left text-uppercase">Invite collaborator to account:</th>
                                            <td class="text-left">{{ search['INVITE_COLLABORATE'] ? search['INVITE_COLLABORATE']:'-'}}</td>
                                        </tr>

                                        <tr>
                                            <th scope="row" class="text-left text-uppercase">Publish Reviewgrower widget:</th>
                                            <td class="text-left">{{ search['PUBLISH_WIDGET'] ? search['PUBLISH_WIDGET']:'-'}}</td>
                                        </tr>
                                    </tbody>
                            </table>
                        </div>
                </v-container>

            </div>
            </v-card>
          </div>

        </template>
      </panel-navigation>
    </div>
  
    
  </template>
  
  <script>
  import axios from 'axios'
  import { mapState } from 'vuex'
  import PanelNavigation from '@/components/PanelNavigation.vue'
  import MenuUserActions from '@/components/menus/menuUserActions.vue'
  import DialogAddUser from '@/components/dialogs/users/addUser.vue'
  import moment from 'moment'
  
  export default {
    metaInfo () {
      return {
        title: "Users | " + this.$appName
      }
    },
    components: {
      PanelNavigation,
      MenuUserActions,
      DialogAddUser
    },
    data() {
      return {
        search :null,
      }
    },
    computed: {
      ...mapState({
        me: state => state.me.me
      }),
      
    },
    methods: {
        async getSearch(){
            axios.get(process.env.VUE_APP_API_ENDPOINT + '/me/user-details', {
            headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt,
                },
            params: {
            user: this.$route.params.id,
            }
        })
         .then(response => {
                this.search = response.data.data
              

            })
            .catch(error => {
             console.log(error)
            })
    },
        formatDate: function(date) {
        return moment(String(date)).format('MM/DD/YYYY')
        },
    },
    mounted() {
        this.getSearch();
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  .styled-checkbox {
    position: absolute; // take it out of document flow
    opacity: 0; // hide it
  
    & + label {
      position: relative;
      cursor: pointer;
      padding: 0;
    }
  
    // Box.
    & + label:before {
      content: '';
      margin-right: 0px;
      display: inline-block;
      vertical-align: text-top;
      width: 20px;
      height: 20px;
      background: rgb(228, 228, 228);
    }
  
    // Box hover
    /*&:hover + label:before {
      background: #f35429;
    }*/
    
    // Box focus
    &:focus + label:before {
      
      border-width: 0;
    }
  
    // Box checked
    &:checked + label:before {
      background: #48bb78;
    }
    
    // Disabled state label.
    &:disabled + label {
      color: #b8b8b8;
      cursor: auto;
    }
  
    // Disabled box.
    &:disabled + label:before {
      box-shadow: none;
      background: #ddd;
    }
  
    // Checkmark. Could be replaced with an image
    &:checked + label:after {
      content: '';
      position: absolute;
      left: 5px;
      top: 9px;
      background: white;
      width: 2px;
      height: 2px;
      box-shadow: 
        2px 0 0 white,
        4px 0 0 white,
        4px -2px 0 white,
        4px -4px 0 white,
        4px -6px 0 white,
        4px -8px 0 white;
      transform: rotate(45deg);
    }
  }
  
  .btn-invite {
    background-color: #00ad9e;
  }
  
  table tbody tr {
    transition: all 0.1s linear;
  }
  
  table tbody tr:hover {
    background-color: rgb(245, 245, 245);
  }
  
  </style>
  